import script from "./TooltipTrigger.vue?vue&type=script&setup=true&lang=ts"
export * from "./TooltipTrigger.vue?vue&type=script&setup=true&lang=ts"

import "./TooltipTrigger.vue?vue&type=style&index=0&id=29ff09a0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29ff09a0"]])

export default __exports__